import $ from "jquery";
import NewModals from "./new-modals";
import DOMPurify from "isomorphic-dompurify";

export default class MultistepPricingContactForm {
  constructor() {
    this.$modalContainer = $("#contact-us-modal");
    this.$formContainer = $("#multi-step-contact-form");
    this.email = '';

    if (!this.$modalContainer.length || !this.$formContainer) {
      return;
    }

    setTimeout(() => {
      this.loadForms();
    }, 2000);
  }

  loadForms() {
    const src = `//js.hsforms.net/forms/v2${ window.isLegacyIE ? '-legacy' : '' }.js`;
    let script = document.createElement('script');
    script.onload = () => this.setupForms();
    script.src = src;
    script.charset = 'utf-8';
    document.head.appendChild(script);
  }

  setupForms() {
    this.setupHubspotForm("step1");
    this.setupHubspotForm("step2");
    this.setupHubspotForm("step3");
    this.setupHubspotForm("step4");
  }

  setupHubspotForm(formId) {
    hbspt.forms.create({
      portalId: "592061",
      formId: document.getElementById(formId).dataset.formId,
      css: "",
      target: "#" + formId,
      region: "eu1",
      onFormReady: ($form) => {
        this.addFloatingLabels($form);
        $form.addClass('hs-form-new');

        $form
          .find(
            ".hs-dependent-field select, .hs-dependent-field input, .hs-dependent-field textarea"
          )
          .on("change", () => {
            this.addFloatingLabels($form);
          });

        if (formId === 'step2' || formId === 'step3' || formId === 'step4') {
          $form.hide();
        }
      },
      onFormSubmitted: ($form, values) => {
        this.onAfterFormSubmission(values, formId);
      },
      translations: {
        en: {
          required: "The field cannot be left blank.",
          invalidEmail: "Please enter a valid email address.",
          invalidEmailFormat: "Please enter a valid email address.",
          phoneInvalidCharacters:
            "Valid phone number can contain only numbers, +()-. and x.",
          phoneInvalidLengthOrFormat: "Please enter a valid phone number.",
        },
      },
    });
  }

  addFloatingLabels($formContainer) {
    $formContainer.addClass("form-has-floating-labels");
    $formContainer.find(".hs-form-field").each(function (i, elem) {
      let $inputContainer = $(elem).find(".input");
      let $labelContainer = $(elem).find("label").first();
      let $input = $inputContainer
        .find(
          "input[type=text],input[type=tel],input[type=email],input[type=number],select,textarea"
        )
        .first();

      if (!$inputContainer.hasClass("has-float-label") && $input.length > 0) {
        const id = DOMPurify.sanitize($input.attr("id"));
        const label = document.createElement("label");
        label.classList.add("placeholder");
        label.htmlFor = id;
        label.textContent = $labelContainer.text();
        $input.after(label);

        $input.attr("placeholder", $labelContainer.text());
        $inputContainer.addClass("has-float-label");
        $(elem).addClass("label-hide");
      }
    });
  }

  openForm(planSelected) {
    NewModals.open("contact-us-modal");

    if (planSelected) {
      const planFieldName = "trk_plan_selected_on_the_pricing_page";
      this.$formContainer
        .find('input[name="' + planFieldName + '"]')
        .val(planSelected)
        .change();
    }
  }

  onAfterFormSubmission(values, formId) {
    if (formId === 'step1') {
      this.$modalContainer.find('[data-paragraph]').html('How can we get in touch?');
      this.$modalContainer.find('#step1').hide();
      this.$modalContainer.find('#step2 form').show();
      this.$formContainer.find('input[name="email"]').val(values.submissionValues.email).change();
    } else if (formId === 'step2') {
      this.$modalContainer.find('[data-paragraph]').html('What can we help with?');
      this.$modalContainer.find('#step2').hide();
      this.$modalContainer.find('#step3 form').show();
    } else if (formId === 'step3') {
      this.$modalContainer.find('[data-paragraph]').html('Let us learn more about you.');
      this.$modalContainer.find('#step3').hide();
      this.$modalContainer.find('#step4 form').show();
    } else if (formId === 'step4') {
      this.$modalContainer.find('[data-title]').html('Thank you for reaching out!');
      this.$modalContainer.find('[data-paragraph]').html('We\'ll get back to you as soon as possible.');
      this.$modalContainer.addClass('new-modal--success');
      this.$modalContainer.find('#step4').hide();
    }
  }
}